// src/pages/Home.jsx
import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

import HeroSolarAnimation from "../components/HeroSolarAnimation";
import Features from "../components/Features";
import WhoWeAre from "../components/WhoWeAre";
import Advantages from "../components/Advantages";
import StaticHero from "../components/StaticHero";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import NewsCarousel from "../components/NewsCarousel";

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2, when: "beforeChildren" } },
};

const fadeInUpVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

export default function Home() {
  /* ────── si llegamos con /home#servicios hacemos scroll automático ───── */
  const { hash } = useLocation();
  useEffect(() => {
    if (hash === "#servicios") {
      const el = document.getElementById("servicios");
      el && el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash]);

  return (
    <motion.main
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {/* Hero animado */}
      <Box component={motion.div} variants={fadeInUpVariant}>
        <HeroSolarAnimation />
      </Box>

      {/* Características */}
      <Box component={motion.section} variants={fadeInUpVariant} sx={{ pt: 0 }}>
        <Features />
      </Box>

      {/* Quiénes somos */}
      <Box
        component={motion.section}
        variants={fadeInUpVariant}
        sx={{ bgcolor: "#fff" }}
      >
        <WhoWeAre />
      </Box>

      {/* Ventajas */}
      <Box component={motion.section} variants={fadeInUpVariant}>
        <Advantages />
      </Box>

      {/* Testimonios */}
      <Box
        component={motion.section}
        variants={fadeInUpVariant}
        sx={{ bgcolor: "#fff", py: { xs: 6, md: 10 } }}
      >
        <Testimonials />
      </Box>

      {/* CTA / Contacto */}
      <Box component={motion.div} variants={fadeInUpVariant}>
        <StaticHero />
      </Box>

      {/* Preguntas frecuentes */}
      <Box
        component={motion.section}
        variants={fadeInUpVariant}
        sx={{ bgcolor: "#fff", pb: { xs: 4, md: 6 }, pt: { xs: 6, md: 10 } }}
      >
        <FAQ />
      </Box>

      {/* ─── NUEVA sección de noticias ─── */}
      <Box
        component={motion.section}
        variants={fadeInUpVariant}
        sx={{ bgcolor: "#fff", pt: { xs: 4, md: 6 }, pb: { xs: 8, md: 12 } }}
      >
        <NewsCarousel />
      </Box>
    </motion.main>
  );
}
